import React from 'react';
import { useTranslation } from 'react-i18next';

interface ClientInfoProps {
  clientName: string;
  setClientName: (name: string) => void;
  clientDescription: string;
  setClientDescription: (description: string) => void;
  totalDurationWithTasks?: { hours: number; minutes: number } | null;
  activeTasks?: number;
  driversAssigned?: number;
}

const ClientInfo: React.FC<ClientInfoProps> = ({
  clientName,
  setClientName,
  clientDescription,
  setClientDescription,
  totalDurationWithTasks,
  activeTasks,
  driversAssigned,
}) => {
  const { t } = useTranslation('client');

  return (
    <>
      <div className="flex flex-col px-6 py-4 gap-4">
        <h6 className="font-medium text-subtitle-1">
          {t('detail.client_info')}
        </h6>
      </div>
      <div className="grid grid-cols-5">
        <div className="flex flex-col col-span-2 gap-6 px-6 mb-4">
          <div className="flex flex-col gap-1">
            <label
              htmlFor="clientName"
              className="text-caption text-neutral/100"
            >
              {t('detail.client_name')} <span className="text-error">*</span> (
              {clientName.length}/30)
            </label>
            <input
              id="clientName"
              type="text"
              maxLength={30}
              value={clientName}
              onChange={(e) => setClientName(e.target.value)}
              className="h-10 border border-neutral/50 text-neutral/300 focus:outline-none focus:border-neutral/75 text-caption rounded py-2 px-4"
              required
            />
          </div>
          <div className="flex flex-col gap-1">
            <label
              htmlFor="clientDescription"
              className="text-caption text-neutral/100"
            >
              {t('detail.client_description')}{' '}
              <span className="text-error">*</span> ({clientDescription.length}
              /100)
            </label>
            <textarea
              id="clientDescription"
              maxLength={100}
              value={clientDescription}
              onChange={(e) => setClientDescription(e.target.value)}
              className="h-20 border border-neutral/50 text-neutral/300 focus:outline-none focus:border-neutral/75 text-caption rounded py-2 px-4 resize-none"
              required
            />
          </div>
        </div>
        <div className="flex flex-row col-span-3 gap-10 pl-24">
          <div className="flex flex-col w-full gap-1">
            <label
              htmlFor="totalDuration"
              className="text-caption text-neutral/100"
            >
              {t('detail.total_duration')}
            </label>
            <p className="text-medium text-h5 text-neutral/300">
              {totalDurationWithTasks
                ? `${totalDurationWithTasks.hours} hrs ${totalDurationWithTasks.minutes} min`
                : totalDurationWithTasks !== undefined
                ? '0 min'
                : '-'}
            </p>
          </div>
          <div className="flex flex-col w-full gap-1">
            <label
              htmlFor="activeTasks"
              className="text-caption text-neutral/100"
            >
              {t('detail.active_task')}
            </label>
            <p className="text-medium text-h5 text-neutral/300">
              {activeTasks !== undefined ? activeTasks : '-'}
            </p>
          </div>
          <div className="flex flex-col w-full gap-1">
            <label
              htmlFor="driverAssigned"
              className="text-caption text-neutral/100"
            >
              {t('detail.driver_assigned')}
            </label>
            <p className="text-medium text-h5 text-neutral/300">
              {driversAssigned !== undefined ? driversAssigned : '-'}
            </p>
          </div>
        </div>
      </div>
    </>
  );
};

export default ClientInfo;
